export interface CustomWindow extends Window {
    config?: any;
}

export function getEnv(name: string): string {
    const w = window as CustomWindow;
    return w.config?.['PRDIS_' + name];
}